import { graphql } from '@api/generated';
import { getClient } from '../../../api/client';
import { CombinedGraphQLErrors } from '@apollo/client';

const updateCallTimeoutWarningSettingMutation = graphql(`
  mutation updateCallTimeoutWarningSettingMutation(
    $contactCenterSettings: ContactCenterSettingsInput!
  ) {
    updateContactCenterSettings(contactCenterSettings: $contactCenterSettings) {
      callTimeoutWarning {
        isEnabled
      }
    }
  }
`);

async function updateCallTimeoutWarningSetting(
  isEnabled: boolean,
): Promise<boolean> {
  const { data, error } = await getClient().mutate({
    mutation: updateCallTimeoutWarningSettingMutation,
    variables: {
      contactCenterSettings: {
        callTimeoutWarning: {
          isEnabled,
        },
      },
    },
  });

  if (CombinedGraphQLErrors.is(error) && error.errors.length > 0) {
    throw new Error(error.errors[0].message);
  }

  return (
    data?.updateContactCenterSettings?.callTimeoutWarning?.isEnabled ??
    isEnabled
  );
}

export default updateCallTimeoutWarningSetting;
